
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[locale]/reset/password/send",
      function () {
        return require("private-next-pages/[region]/[locale]/reset/password/send.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[locale]/reset/password/send"])
      });
    }
  